<template>
    <v-container>
        <v-card v-if="recentNews" class="my-4">
            <v-card-title>Νέα</v-card-title>
            <v-card-text>
                <ul>
                    <li v-for="newsEntry in newsEntries" v-bind:key="newsEntry.id"> {{ newsEntry.date }} - <span v-html="newsEntry.contents"></span> </li>
                </ul>
            </v-card-text>
        </v-card>

        <v-spacer></v-spacer>

        <v-card class="my-4">
            <v-card-title>Κατάσταση MyData</v-card-title>
            
            <v-card-text>
                   <v-data-table
                    :headers="headers"
                    :items="myDataLogs"
                    :item-class="tableRowClassGenerator"
                    :sort-by="['success', 'issue_date', 'document_type', 'document_number']"
                    :sort-desc="[false, true, false, true]"
                    class="elevation-1"
                    disable-pagination
                    hide-default-footer>
                    </v-data-table>
            </v-card-text>
        </v-card>
    </v-container>
    
</template>

<script>
export default {
    data() {
        return {
                
            newsEntries: [],
            myDataLogs: [],

            headers: [
                { 
                    text: 'Έκδοση',
                    align: 'center', 
                    value: 'issue_date', 
                },
                { 
                    text: 'Παραστατικό',
                    align: 'center', 
                    value: 'document_type', 
                },
                { 
                    text: 'Αριθμός',
                    align: 'center', 
                    value: 'document_number', 
                },
                { 
                    text: 'Πελάτης',
                    align: 'center', 
                    value: 'customer_name', 
                },
                { 
                    text: 'Ανέβασμα',
                    align: 'center', 
                    value: 'created_at', 
                },
                { 
                    text: 'Απάντηση ΑΑΔΕ',
                    align: 'center', 
                    value: 'message', 
                },
            ],


        }
    },

    created() {
        this.initialize();
    },

    methods: {
        initialize() {
            this.newsItems = [
                {
                    id: 1,
                    date: "22/02/2022",
                    text: "Φθίνουσα ταξινόμηση παραστατικών με ημερομηνία, τα πιο πρόσφατα θα είναι πλέον <strong>πιο πάνω</strong> στις λίστες"
                }
            ]

            axios.get('/api/mydata')
            .then(response =>  {
                this.myDataLogs = response.data
            })

            axios.get('/api/news')
            .then(response => {
                this.newsEntries = response.data
            })
        },

        tableRowClassGenerator(item) {

            if (item.success == 0)
                return 'red lighten-3'

            return 'green lighten-4'
      },
    },

    computed: {
        myDataErrors() {
            return this.myDataLogs.filter(x => x.success == 0).length > 0
        },


        recentNews() {
            return this.newsEntries.length > 0
        }
    }
}
</script>
